const key = 'CKP_API_TOKEN';
const contractEventIdKey = 'CKP_CONTRACT_EVENT';
const contractDueDateKey = 'CKP_CONTRACT_DUE';
const lastEventKey = 'CKP_LAST_EVENT';
const contractFilter = name => `CKP_CONTRACT_FILTER_${name}`;

export const storeToken = (token, remember) => (remember ? localStorage : sessionStorage).setItem(key, token);
export const clearToken = () => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
};
export const getToken = () => getTokenLocal() || getTokenSession();
export const getTokenLocal = () => localStorage.getItem(key);
export const getTokenSession = () => sessionStorage.getItem(key);

export const storeContractEvent = eventId => sessionStorage.setItem(contractEventIdKey, eventId);
export const getContractEvent = () => sessionStorage.getItem(contractEventIdKey);

export const storeContractDueDate = date => sessionStorage.setItem(contractDueDateKey, date);
export const getContractDueDate = () => sessionStorage.getItem(contractDueDateKey);

export const storeLastEvent = eventId => sessionStorage.setItem(lastEventKey, eventId);
export const getLastEvent = () => sessionStorage.getItem(lastEventKey);

export const storeContractFilter = (filterName, value) => sessionStorage.setItem(contractFilter(filterName), value);
export const getContractFilter = filterName => sessionStorage.getItem(contractFilter(filterName));
